import React, {createRef} from "react"
import {findDOMNode} from "react-dom"

import VScroll from "../../../scrolling/custom-v-scroll/v-scroll"
import ProjectSession from "../../../../model2/project/project-session"
import ProjectTree_New, {
    ITreeSelectorParent
} from "../../../../gd-ui/select-parent-new/components/tree-new/project-tree-new"
import {EntityType} from "../../../../gd/const/item"
import {ProjectsTreeSortType} from "../../../../model2/space/@types"
import {entitySelectorProjectSpaces} from "./functions/get-spaces"

type Props = {
    selectedProjectId?      : ID
    highlightedProjectId?   : ID

    // ITreeSelectorParent.props -- read straight off `this.props` (React's own),
    // same trick `ModalMoveTo_ProjectsTree` uses: no "select nothing" root row,
    // and the workspace itself renders as the tree's own top-level node.
    canBeNull               : boolean
    displayWorkspaceRoot    : boolean

    onSelectProject         : {(projectId?: ID):void}
}

// const debug = "EntitySelectorProjectsTree"
const debug = false

// Same tree "Move to" renders (`ModalMoveTo_ProjectsTree`), one `ProjectTree_New`
// per space, minus the coupling to `MoveTo_Manager` -- this picks a project to
// relate/mention, not to move one.
export default class EntitySelectorProjectsTree extends React.Component<Props> implements ITreeSelectorParent {

    private refScroll   : any = createRef()
    public multiselect  : boolean = false       // needed for tree interface

    static defaultProps = {
        canBeNull               : false,
        displayWorkspaceRoot    : true,
    }

    componentDidMount() {
        // Deferred a tick: `ProjectFinderMain.updateInitialExpand` -- which
        // expands this project's ancestors -- runs in ITS OWN componentDidMount,
        // which fires AFTER this one (children mount before parents), so the
        // node is not in the DOM yet if this ran synchronously. Same fix
        // `ModalMoveTo_ProjectsTree.scrollToTarget` applies, for the same reason.
        setTimeout(() => {
            this.scrollToProject(this.value)
        }, 0)
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.highlightedProjectId && prevProps.highlightedProjectId !== this.props.highlightedProjectId) {
            this.scrollToProject(this.props.highlightedProjectId)
        } else if (this.props.selectedProjectId && prevProps.selectedProjectId !== this.props.selectedProjectId) {
            this.scrollToProject(this.props.selectedProjectId)
        }
    }

    // Interface methods
    get parentsFor():EntityType {
        return EntityType.PROJECT
    }

    get value():ID | null {
        return this.props.selectedProjectId || null
    }

    get selectedProjects():ID[] {
        return this.value ? [this.value] : []
    }

    get highlightedProjectId():ID | undefined {
        return this.props.highlightedProjectId
    }

    scrollToProject = (projectId?: ID | null) => {
        if (!projectId) {
            return
        }

        const selfNode: any = findDOMNode(this.refScroll.current)
        const node = selfNode?.getElementsByClassName('projectId-{0}'.f(projectId))[0]

        debug && console.log(debug, "scrollToProject node", projectId, node?.offsetTop, node)

        if (node) {
            this.refScroll.current?.setScrollTop(node.offsetTop + node.clientHeight/2, true, 0)
        }
    }

    onToggleExpand = (project: ProjectSession) => {
        project.treeIsExpandedProjectSelector = !project.treeIsExpandedProjectSelector
        this.forceUpdate()
    }

    render() {
        const spaces = entitySelectorProjectSpaces()

        debug && console.log(debug, 'render', spaces, this.selectedProjects)

        return (
            <VScroll
                ref             = {this.refScroll}
                containerClass  = "p-t-10 p-b-10 p-r-5 p-l-8"
            >
                <div className="ui5-menu p-0">
                    {_.map(spaces, space=>{
                        return (
                            <ProjectTree_New
                                key                 = {space.id}
                                parentSelector      = {this}
                                sortType            = {ProjectsTreeSortType.ALPHABETICAL}
                                rootProjects        = {space.rootProjects}
                                section             = {space}
                                initialRootExpanded = {true}
                                applyTreeDisplay    = {true}
                                onSelect            = {this.props.onSelectProject}
                                onToggleExpand      = {this.onToggleExpand}
                            />
                        )
                    })}
                </div>
            </VScroll>
        )
    }
}
